import {
  TToolArgument,
  TToolArgumentEditor,
  TTToolTypeArgumentsView,
  TToolArgumentValueType,
  TToolTypeArguments,
} from '@intone/shared/types';

function defaultValueByType(argType?: TTToolTypeArgumentsView, defaultValue?: string | number | boolean): string | number | boolean {
  if (defaultValue != null && defaultValue !== '') return defaultValue;
  if (argType === 'checkbox') return false;
  if (argType === 'number') return 0;
  return '';
}

/** Merges required_arguments and saved tool.arguments into a single list, EditorArg */
export function buildEditorArgs(
  required: TToolTypeArguments[],
  saved: TToolArgument
): TToolArgumentEditor[] {
  const result: TToolArgumentEditor[] = [];

  const savedKeys = new Set(Object.keys(saved || {}));

  //required_arguments (fixed name, cannot be removed)
  required?.forEach((ra, idx) => {
    const savedArg = saved?.[ra.name];

    result.push({
      id: `req-${idx}`,
      name: ra.name,
      is_required: ra.is_required,
      argType: ra.type,
      valueType: (savedArg?.valueType as TToolArgumentValueType) || 'fixed_value',
      value: savedArg?.value ?? defaultValueByType(ra.type, ra.default_value),
      description: ra.description,
      placeholder: ra.placeholder,
      options: ra.options,
      fromRequired: true,
    });
    savedKeys.delete(ra.name);
  });

  // Optional arguments saved previously but not included in required
  Array.from(savedKeys).forEach((name, i) => {
    const s = saved[name] || {}
    result.push({
      id: `extra-${i}`,
      name,
      is_required: false,
      argType: s.argType as TTToolTypeArgumentsView | undefined,
      valueType: (s.valueType as TToolArgumentValueType) || 'fixed_value',
      value: s.value ?? '',
      fromRequired: false,
    })
  });

  return result;
}
